import { PartnerDashboardShellTemplate } from "~mangomap-ui/templates/partner-dashboard-shell-template";
import { getRecurlyHostedBillingInfoUrl } from "~utils/recurly/get-recurly-hosted-billing-info-url";
import { useRouter } from "next/router";
import { type FC, type ReactNode } from "react";

import { usePartnerAuth } from "../context";

interface PartnerDashboardPageWrapperProps {
	children?: ReactNode;
}

export const PartnerDashboardPageWrapper: FC<
	PartnerDashboardPageWrapperProps
> = ({ children }) => {
	const router = useRouter();
	const { partner, signOut } = usePartnerAuth();
	const isPortfolioActive = router.pathname.startsWith("/portfolios");
	const isInvoicesActive = router.pathname === "/invoices";
	const paymentMethod = partner?._recurlyAccountInfo?.paymentMethod;
	const hostedToken = partner?._recurlyAccountInfo?.hostedToken ?? "";
	const hasPaymentMethodOnFile = Boolean(paymentMethod?.lastFour);

	return (
		<PartnerDashboardShellTemplate
			partner={
				partner
					? {
							id: partner.id,
							companyName: partner.companyName,
							contactEmail: partner.contactEmail,
							firstName: partner.firstName,
							lastName: partner.lastName,
							isSuspended: partner.isSuspended ?? false,
							trialLengthDays: 0,
							defaultTrialPlan: "ENTERPRISE",
							defaultTrialBillingCycle: "MONTHLY",
							recurlyAccountCode: partner.recurlyAccountCode ?? "",
							recurlyHostedAccountManagementUrl: "",
							recurlyHostedBillingInfoUrl: hostedToken
								? getRecurlyHostedBillingInfoUrl(hostedToken)
								: "",
							hasPaymentMethodOnFile,
							paymentMethodSummary: hasPaymentMethodOnFile
								? {
										cardBrand: paymentMethod?.cardType ?? "N/A",
										cardLastFour: paymentMethod?.lastFour ?? "",
									}
								: null,
						}
					: null
			}
			onSignOut={() => void signOut()}
			onOpenPortfolio={() => void router.push("/portfolios")}
			isPortfolioActive={isPortfolioActive}
			onOpenInvoices={() => void router.push("/invoices")}
			isInvoicesActive={isInvoicesActive}
			onOpenBillingInfo={(url) => {
				if (!url) return;
				window.open(url, "_blank", "noopener,noreferrer");
			}}>
			{children}
		</PartnerDashboardShellTemplate>
	);
};
